import { j as i } from "../../../jsx-runtime-B6kdoens.js";
import { useContext as m } from "react";
import { c as p } from "../../../index-CROKJrb5.js";
import { Typography as x } from "../../Typography/index.js";
import { c as l } from "../../../create-component-CBAeEoQ6.js";
import { F as u } from "../../../FormControlContext-C7A4R-3o.js";
const d = p({
  variants: {
    state: {
      "": null,
      critical: "cur-text-error",
      warning: "cur-text-warning",
      success: "cur-text-success"
    },
    disabled: {
      true: "cur-text-disabled",
      false: "cur-text-inherit"
    },
    checkboxOrRadio: {
      true: "cur-mb-1",
      false: "cur-mt-1"
    }
  }
}), F = l("FormControlHelperText", ({ children: r, context: e, ...o }) => {
  const s = m(u), { disabled: a = !1, state: c, type: t } = e ?? s, n = d({
    disabled: a,
    state: c,
    checkboxOrRadio: t === "checkbox" || t === "radio"
  });
  return /* @__PURE__ */ i.jsx(
    x,
    {
      size: "meta",
      className: n,
      ...o,
      children: r
    }
  );
});
export {
  F as FormControlHelperText
};
//# sourceMappingURL=index.js.map
